export const TIMESHEET = "TIMESHEET";
export const TIMESHEET_SUCCESS = "TIMESHEET_SUCCESS";
export const TIMESHEET_FAILED = "TIMESHEET_FAILED";

export const ADD_TIMESHEET = "ADD_TIMESHEET";
export const ADD_TIMESHEET_SUCCESS = "ADD_TIMESHEET_SUCCESS";
export const ADD_TIMESHEET_FAILED = "ADD_TIMESHEET_FAILED";

export const UPDATE_TIMESHEET = "UPDATE_TIMESHEET";
export const UPDATE_TIMESHEET_SUCCESS = "UPDATE_TIMESHEET_SUCCESS";
export const UPDATE_TIMESHEET_FAILED = "UPDATE_TIMESHEET_FAILED";
